import { ButtonBase, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: '6px 15px',
    borderRadius: '30px',
    transition: 'all 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.normalBlue,
    },
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.normalBlue}`,
    boxShadow: theme.shadows[1],
    height: '34px',
    maxHeight: '34px',
  },
}));

const BlackWhiteButton = (props) => {
  const classes = useStyles();
  return (
    <ButtonBase
      type="button"
      {...props}
      className={classes.button}
      sx={{
        border:
          (props?.deletepickup === true && localStorage.getItem('create4thobj') && '1px solid lightgrey') ||
          (props?.deletedropoff === true && localStorage.getItem('create4thobj') && '1px solid lightgrey'),
        ...(props.sx ? props.sx : {}),
        backgroundColor: props?.disabled ? 'lightgrey !important' : 'white',
      }}
    >
      {props.icon && <props.icon />}
      <Typography
        variant="blackButtonText"
        sx={{
          color:
            (props?.deletepickup === true && localStorage.getItem('create4thobj') && 'lightgrey') ||
            (props?.deletedropoff === true && localStorage.getItem('create4thobj') && 'lightgrey'),
          ...(props.typosx ? props?.typosx : {}),
        }}
      >
        {props.title}
      </Typography>
    </ButtonBase>
  );
};

export default BlackWhiteButton;
